export default __webpack_public_path__ + "static/media/microsoft.24771bdc.svg";